export default {
    props: {
        show: Boolean
    },
    name: 'Restricted'
};
